const words = ["Most wanted", "Headphones", "Glow serums", "Quencher tumblers", "Aero runners", "Free shipping over $150", "Pay by debit card"];

export function Marquee() {
  const row = [...words, ...words];
  return (
    <div className="marquee-wrap overflow-hidden border-y border-[var(--ink)] bg-[var(--ink)] py-5 text-[var(--bone)] md:py-7" data-testid="editorial-marquee">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((k) => (
          <div key={k} className="flex items-center" aria-hidden={k === 1}>
            {row.map((w, i) => (
              <span key={`${k}-${i}`} className="flex items-center">
                <span className={`font-display px-6 text-3xl md:px-10 md:text-5xl ${i % 2 ? "italic text-[var(--terra)]" : ""}`}>{w}</span>
                <svg viewBox="0 0 20 20" className="h-4 w-4 fill-[var(--bone)]"><path d="M10 0l2.5 7.5L20 10l-7.5 2.5L10 20l-2.5-7.5L0 10l7.5-2.5z" /></svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
